<template lang="pug">
div
	page-header(:title='title', :url='url', :titleNew='titleNew')
	vue-element-loading(:active='isActive' spinner='bar-fade-scale' color='#428BCA')
	grid(
		ref="grid" 
		:url='urlDataSource'
		:columns='columns'
		:GridHeight="400"
		:GridPageable="true"
		:DSpageSize="8"
		:DSserverPaging="true"
		:DSschema="true"
		:DSschemaData="'data'"
		:DSschemaTotal="'total'"
		:DSschemaParse="parse"
		:GridPageablePageSizes="[1, 10, 20, 100]"
	)
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import Grid from '@/components/Grid'

import GridTemplate from '@/mixins/GridTemplate'
import Permission from '@/mixins/Permission'

import { confirme, erro, sucesso } from '@/components/Message'
import req from '@/components/request'
 
export default {
	mixins: [GridTemplate, Permission],
	components: {
		VueElementLoading,
		PageHeader,
		Grid
	},
	data() {
		return {
			title: 'Páginas',
			titleNew: '',
			url: '/links/paginas/',
			urlDataSource: `${this.$url}/v1/paginas?status=1&offset=8`,
			columns: [{
				field: 'titulo',
				title: 'Título',
				width: 400
			}, {
				field: 'active_name',
				title: 'Ativo',
				width: 120
			}],
			isActive: false,
		}
	},
	methods: {
		verifPermissao() {
			this.titleNew = this.ACTION.c ? 'Novo' : ''
			if (this.ACTION.e || this.ACTION.d) {
				this.columns.push({
					field: 'ativo',
					title: 'Ações',
					width: 105,
					template: this.commandTemplate
				})
			}
		},
		parse(d) {
			d.data.map(i => {
				return i
			})
			return d
		},
		async buttonClickApagar(item) {
			const result = await confirme(item.titulo,'Tem certeza que deseja remover esse registro? pois a exclusão é irreversível e não é possível voltar os dados')
			if(result.isConfirmed) {
				this.isActive = true
				await req(`/v1/paginas/${item.id}`, 'delete').catch(response => {
					'error: ' + response
					erro()
				})
				sucesso('Atualizado...')
				this.$refs.grid.$refs.datasource1.kendoDataSource.read()
			}
			this.isActive = false
		}
	},
	created() {
		this.verifPermissao()
	}
}
</script>

<style lang="stylus" scoped>

</style>
